import { MatchmakingItem, MatchmakingPost } from '@/types/types'

export function useMathmakingUtils() {
  return { matchmakingTypeLabelTranslator }
}

function matchmakingTypeLabelTranslator(
  item: MatchmakingItem | MatchmakingPost | undefined | null
) {
  if (!item) return ''
  if (item.requirement === 'accessible_alternative_outlets' || item.offer_public_actor) {
    return 'Erbjuder mark för'
  } else if (item.offer || item.type === 'supply') {
    return 'Erbjuder'
  }
  return 'Söker'
}
